<template>
    <div class="card shadow-sm">
        <div class="card-body">
            <div class="row" v-if="addresses.length">
                <div class="col-md-6"  v-for="address in addresses">
                    <div class="card bg-light mb-2">
                        <div class="card-body p-3">
                            <h5 class="card-title" v-if="address.is_invoice">
                                {{ $t("pages.account.address.label_invoice") }}
                            </h5>
                            <h5 class="card-title" v-else-if="address.is_delivery">
                                {{ $t("pages.account.address.label_delivery") }}
                            </h5>
                            <hr>

                            <p class="pb-0">
                                <strong>{{ address.full_name }}</strong><br>
                                {{ address.address_one }}<br>
                                {{ address.address_two }}<br>
                                {{ address.postal_code }} {{ address.city }}<br>
                                {{ address.country_name }}
                            </p>

                            <p>
                                <router-link tag="a" :to="{name: 'account.address.edit', params: {type: address.is_invoice ? 'invoice' : 'delivery'}}" class="btn btn-outline-dark">
                                    <i class="mdi mdi-pencil"></i>
                                    {{ $t('actions.edit') }}
                                </router-link>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row" v-else>
                <div class="col-md-12">
                    <div class="alert alert-secondary border-dark shadow-sm">
                        {{ $t('pages.account.address.none') }}
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import AccountRepository from "../../../../repositories/Account/AccountRepository";

export default {
    name: "AddressManagement",
    data: () => ({
        addresses: [],
    }),
    methods: {
        getAddresses() {
            AccountRepository.getAddresses()
                .then((res) => this.addresses = res.data);
        }
    },
    mounted() {
        this.getAddresses();
    }
}
</script>

<style scoped>

</style>
